import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Cliente } from '../../../models/cliente.model';
import { FormatadorHelper } from '../../../helpers/formatador.helper';
import { descricaoIdentificacaoCpfCnpj, IdentificacaoCpfCnpj } from '../../../models/enums/identificacao-cpf-cnpj.enum';




@Component({
  selector: 'app-clientes-detalhes',
  templateUrl: './clientes-detalhes.component.html',
  styleUrls: ['./clientes-detalhes.component.scss'],
})
export class ClientesDetalhesComponent {
  @Input() cliente: Cliente | null = null;
  @Output() close = new EventEmitter<void>();

  formatarCpfCnpj(cpfCnpj: string): string {
    return FormatadorHelper.formatarCpfCnpj(cpfCnpj);
  }

  formatarTelefone(telefone: string): string {
    return FormatadorHelper.formatarTelefone(telefone);
  }

  enderecoCompleto(cliente: Cliente): string {
    return `${cliente.logradouro || ''}, ${cliente.municipio || ''}, ${cliente.numero || ''}, ${
      cliente.complemento || ''
    }, ${cliente.bairro || ''}, ${cliente.municipio || ''}, ${cliente.uf || ''}, ${
      cliente.cep || ''
    }, ${cliente.pais || ''}`;
  }  

  getTipoDocumento(cpfCnpj: string): string {
    if (FormatadorHelper.ehCpf(cpfCnpj)) {
      return descricaoIdentificacaoCpfCnpj[IdentificacaoCpfCnpj.Cpf];
    }

    if (FormatadorHelper.ehCnpj(cpfCnpj)) {
      return descricaoIdentificacaoCpfCnpj[IdentificacaoCpfCnpj.Cnpj];
    }

    return 'Desconhecido';
  }
  
  closeDialog() {
    this.close.emit(); 
  }
}
